/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plugins_Audio_DescriptionInputs */

const en_plugins_audio_description = /** @type {(inputs: Plugins_Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plugins: Audio Description`)
};

const fr_plugins_audio_description = /** @type {(inputs: Plugins_Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plugins : Description audio`)
};

const de_plugins_audio_description = /** @type {(inputs: Plugins_Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plugins: Audiobeschreibung`)
};

const it_plugins_audio_description = /** @type {(inputs: Plugins_Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plugin: Descrizione audio`)
};

const ru_plugins_audio_description = /** @type {(inputs: Plugins_Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Плагины: Аудиоописание`)
};

const es_plugins_audio_description = /** @type {(inputs: Plugins_Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complementos: Descripción de audio`)
};

const zh_cn2_plugins_audio_description = /** @type {(inputs: Plugins_Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`插件：音频描述`)
};

const ja_plugins_audio_description = /** @type {(inputs: Plugins_Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プラグイン: オーディオ説明`)
};

const hi_plugins_audio_description = /** @type {(inputs: Plugins_Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्लगइन्स: ऑडियो विवरण`)
};

const pt_pt2_plugins_audio_description = /** @type {(inputs: Plugins_Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plugins: Descrição de áudio`)
};

/**
* | output |
* | --- |
* | "Plugins: Audio Description" |
*
* @param {Plugins_Audio_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plugins_audio_description = /** @type {((inputs?: Plugins_Audio_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plugins_Audio_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_plugins_audio_description(inputs)
	if (locale === "de") return de_plugins_audio_description(inputs)
	if (locale === "it") return it_plugins_audio_description(inputs)
	if (locale === "ru") return ru_plugins_audio_description(inputs)
	if (locale === "es") return es_plugins_audio_description(inputs)
	if (locale === "zh-CN") return zh_cn2_plugins_audio_description(inputs)
	if (locale === "ja") return ja_plugins_audio_description(inputs)
	if (locale === "hi") return hi_plugins_audio_description(inputs)
	if (locale === "pt-PT") return pt_pt2_plugins_audio_description(inputs)
	return en_plugins_audio_description(inputs)
});